import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useForm } from "react-hook-form";
import { useLocation, useOutletContext } from "react-router-dom";

import invariant from "tiny-invariant";

import CreateGameForm from "./components/CreateGameForm";
import { ICreateGameData } from "./types/creategame";

import "../../assets/css/majorybl/pages/clubhouse.scss";
import ErrorBoundary from "../../components/ErrorBoundary";
import { selectSelectedTeam } from "../../features/clubhouse/clubhouseSlice";
import { selectSelectedLeague } from "../../features/leaguemgmt/leagueManagementSlice";
import { useAppSelector } from "../../hooks/reduxHooks";
import { IGame } from "../../types/api";

const CreateGame = (): React.JSX.Element => {
    const { schedule, setSchedule } = useOutletContext() as {
        schedule: IGame[];
        setSchedule: React.Dispatch<React.SetStateAction<IGame[]>>;
    };

    const selectedTeam = useAppSelector(selectSelectedTeam);

    const location = useLocation();

    const isOnLeagueManagementPage = /league-management/.test(
        location.pathname,
    );

    const league = isOnLeagueManagementPage
        ? useAppSelector(selectSelectedLeague)
        : useAppSelector(state => state.clubhouse.league);

    const methods = useForm<ICreateGameData>({
        mode: "onChange",
        shouldUnregister: true,
        defaultValues: {
            home: isOnLeagueManagementPage
                ? undefined
                : { value: selectedTeam?.id, label: selectedTeam?.name },
            visitor: undefined,
            datetime: undefined,
            diamond: undefined,
            field: undefined,
            note: undefined,
        },
    });

    try {
        invariant(league);
    } catch (error) {
        return <ErrorBoundary error={error} />;
    }

    return (
        <section className="createGameInfo" data-testid="createGameContent">
            <h2>Schedule Game</h2>
            <CreateGameForm
                methods={methods}
                league={league}
                schedule={schedule}
                setSchedule={setSchedule}
                isOnLeagueManagementPage={isOnLeagueManagementPage}
            />
        </section>
    );
};

export default CreateGame;
